import Vue from 'vue'
import VueResource from 'vue-resource'
import { ApiUtil as api } from '@/utils/api.util'

Vue.use(VueResource)

export class FileService {
  static URL = process.env.API_URL + process.env.API_VER
  static RESOURCE = '/files'

  static all (queryParams = {}) {
    return api.get(this.URL + this.RESOURCE, queryParams)
  }

  static upload (data) {
    return Vue.http
      .post(this.URL + this.RESOURCE, data, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      .then(
        response => {
          return response
        },
        error => {
          return error
        }
      )
  }

  static delete (id, queryParams = {}) {
    return api.delete(this.URL + this.RESOURCE + '/' + id, queryParams)
  }

  // new upload route
  static uploadFile (data) {
    return api.post(this.URL + this.RESOURCE + '/upload', data)
  }


  static update (id, data) {
    return api.put(this.URL + this.RESOURCE + '/' + id, data)
  }

  static generatethumbnail (data) {
    return api.post(this.URL + this.RESOURCE + '/generate-thumbnail', data)
  }

  static checkLink (queryParams = {}) {
    return api.get(this.URL + this.RESOURCE + '/check/link/', queryParams)
  }

  static chart (queryParams = {}) {
    return api.get(this.URL + this.RESOURCE + '/chart', queryParams);
  }
}



// WEBPACK FOOTER //
// ./src/services/file.service.js